/*

  # Conform Rich Text (WordPress)

  Conforms specific rich text elements from
  the Block editor to match other rich text
  output.

*/

import { assignController, selectAll, setClassState } from '../api/element-manipulation'

assignController('conformRichText', element => {
  selectAll(element, '.wp-block-image').forEach ( container => {
    let figure = container.querySelector('figure')
    if (!figure) {
      figure = container
    }
    const img = figure.querySelector('img')
    const className = figure.className
    setClassState(img, className)
    container.parentNode.insertBefore(img, container)
    container.parentNode.removeChild(container)
  })
})
